export function shouldShowMatchPageBackToLobby(matchData) {
  const status = matchData?.status;
  return status === "FINISHED" || status === "CANCELLED";
}
